import type React from 'react'

import PageTitle from '@frontend/features/pages/components/PageTitle'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import { parseHtml } from '@frontend/libs/utils'
import { cn } from '@nextui-org/react'
import ErrorBoundary from '@shared/ErrorBoundary'
import NotFound from '@shared/screens/NotFound'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'

import PageLoader from '../features/pages/components/PageLoader'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { slug } = useParams<{ slug: string }>()
  const { data: post, error, isLoading } = usePostBySlug(slug!)

  if (isLoading) return <PageLoader />

  if (error) {
    if ((error as { code?: string })?.code === 'not_found') {
      return <NotFound />
    }
    toast.error('Failed to fetch post')
    showBoundary(error)
  }

  if (!post) {
    showBoundary('No response data')
    return <></>
  }

  document.title = post.meta.title

  const styleTag = document.getElementById('core-block-supports-inline-css')

  if (styleTag) {
    styleTag.innerHTML = post.styles
  } else {
    const style = document.createElement('style')
    style.id = 'core-block-supports-inline-css'
    document.head.appendChild(style)
    style.innerHTML = post.styles
  }

  const { showTitle } = post.options

  return (
    <div
      className={cn({
        'mb-12': !showTitle,
        'my-12': showTitle,
      })}
    >
      {showTitle && <PageTitle title={post.title} />}
      {parseHtml(post.content)}
    </div>
  )
}

export function Single(): null | React.JSX.Element {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default Single
